export const STORAGE_SERVICE = {
  PROMO_CODE: 'promoCode',
}

import { isPWA } from '~/util/isPwa'
import { PwaStorageService } from './storage/pwa'
import { WebStorageService } from './storage/web'

let actualInstance = null

// Создаём прокси-объект. Любой вызов storageService.anyMethod => идёт в actualInstance.anyMethod
export const storageService = new Proxy(
  {},
  {
    get(target, prop, receiver) {
      if (!actualInstance) {
        throw new Error('StorageService не инициализирован. Сначала вызовите initStorageService()')
      }
      return Reflect.get(actualInstance, prop, actualInstance)
    },
    set(target, prop, value, receiver) {
      if (!actualInstance) {
        throw new Error('StorageService не инициализирован. Сначала вызовите initStorageService()')
      }
      return Reflect.set(actualInstance, prop, value, actualInstance)
    },
  }
)

/**
 * Инициализируем реальный экземпляр хранилища (PWA или обычный).
 */
export function initStorageService(context = {}) {
  const url = context?.route?.fullPath || context?.req?.url || ''

  if (isPWA({ url })) {
    actualInstance = new PwaStorageService()
  }
  else {
    actualInstance = new WebStorageService()
  }
}
